// src/pages/LoanBalance/components/exportLoanBalanceCsv.js

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

/**
 * @param {object} params
 * @param {Array}   params.list          - from Redux state.loanBalance.list
 * @param {number}  params.balanceTotal  - from Redux state.loanBalance.balanceTotal
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportLoanBalanceCsv = ({
  list,
  balanceTotal,
  title    = "Loan Balance Report",
  filename = "loan_balance",
}) => {
  const headers = [
    "No.", "Account Name", "Opening Balance",
    "Received Amount", "Payment Amount", "Balance",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.acc_name       || "",
    fmt(row.opening_balance),
    fmt(row.received_total),
    fmt(row.payment_total),
    fmt(row.balance),
  ].map(escape));

  const openingTotal  = list.reduce((s, r) => s + Number(r.opening_balance || 0), 0);
  const receivedTotal = list.reduce((s, r) => s + Number(r.received_total  || 0), 0);
  const paymentTotal  = list.reduce((s, r) => s + Number(r.payment_total   || 0), 0);

  const totalRow = [
    "Grand Total:", "",
    fmt(openingTotal),
    fmt(receivedTotal),
    fmt(paymentTotal),
    fmt(balanceTotal),
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};